import React from 'react';
import { useMediaQuery, useTheme } from '@material-ui/core';

import HistoryHeader from './HistoryHeader';
import HistoryContentDesktop from './HistoryContentDesktop';
import HistoryContentMobile from './HistoryContentMobile';
import { ICustomTheme } from 'interfaces';

const History = (): JSX.Element => {
  const theme: ICustomTheme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'), { noSsr: true });

  return (
    <React.Fragment>
      <HistoryHeader />
      {isMobile ? <HistoryContentMobile /> : <HistoryContentDesktop />}
    </React.Fragment>
  );
};

export default History;
